import { IErrorMessage } from '@hooks/use-error-message.ts';

export const moviesErrorMessages: IErrorMessage = {
  title: {
    required: 'validation_title_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  genres: {
    required: 'validation_genres_required'
  },
  url: {
    required: 'validation_url_required',
    pattern: 'validation_url_pattern',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  date: {
    required: 'validation_date_required'
  }
};
